import { Link } from "react-router-dom";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";

const sections = [
  {
    title: "1. Einleitung",
    content:
      "Der Schutz Ihrer persönlichen Daten ist SPDB Studio ein wichtiges Anliegen. Wir bearbeiten Personendaten vertraulich und gemäss den gesetzlichen Vorschriften der Schweiz, insbesondere dem neuen Datenschutzgesetz (nDSG, in Kraft seit 1. September 2023).",
  },
  {
    title: "2. Verantwortliche Stelle",
    content:
      "Verantwortlich für die Datenbearbeitung auf dieser Webseite ist:\n\nSPDB Studio\nDenis Plüss\n[Strasse und Hausnummer], [PLZ] [Ort]\nSchweiz\nE-Mail: studio@sbdm-studio.ch",
  },
  {
    title: "3. Datenerhebung beim Besuch der Webseite",
    content:
      "Beim Zugriff auf unsere Webseite werden automatisch Daten technischer Natur erhoben (sogenannte Logfiles), wie IP-Adresse, Datum, Uhrzeit, aufgerufene Seite und Browsertyp. Diese Daten werden ausschliesslich zur Gewährleistung der Sicherheit und Stabilität der Webseite genutzt und nicht mit Ihrer Person verknüpft.",
  },
  {
    title: "4. Kontaktformular und Terminbuchung",
    content:
      "Wenn Sie uns per Kontaktformular anfragen oder unseren Terminbuchungsdienst (Calendly) nutzen, werden die von Ihnen eingegebenen Daten — wie Name, E-Mail-Adresse, Telefonnummer und Objektangaben — zur Bearbeitung Ihrer Anfrage gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.\n\nMit der Nutzung von Calendly erklären Sie sich zusätzlich mit den Datenschutzbestimmungen von Calendly (calendly.com) einverstanden.",
  },
  {
    title: "5. Cookies und Analyse-Tools",
    content:
      "Wir setzen zur Optimierung der Benutzererfahrung Cookies ein. Beim ersten Besuch unserer Webseite werden Sie um Ihre Einwilligung gebeten. Falls wir Analyse-Tools (z.B. Framer Analytics oder Google Analytics) verwenden, geschieht dies zur anonymisierten Auswertung der Webseitennutzung. Sie können der Verwendung von nicht notwendigen Cookies jederzeit widersprechen.",
  },
  {
    title: "6. Ihre Rechte",
    content:
      "Sie haben jederzeit das Recht auf:\n\n— Auskunft über Ihre bei uns gespeicherten Personendaten\n— Berichtigung unrichtiger Daten\n— Löschung oder Sperrung Ihrer Daten\n— Einschränkung der Bearbeitung\n— Widerspruch gegen die Datenbearbeitung\n\nZur Geltendmachung Ihrer Rechte wenden Sie sich bitte per E-Mail an: studio@sbdm-studio.ch",
  },
  {
    title: "7. Datensicherheit",
    content:
      "Wir verwenden eine SSL-Verschlüsselung, um die Übertragung vertraulicher Inhalte zu schützen. Unsere Webseite und Systeme werden durch technische und organisatorische Massnahmen gegen unbefugten Zugriff, Verlust und Missbrauch gesichert.",
  },
  {
    title: "8. Änderungen dieser Datenschutzerklärung",
    content:
      "SPDB Studio behält sich vor, diese Datenschutzerklärung jederzeit anzupassen. Es gilt die jeweils auf dieser Website publizierte Version.\n\nStand: März 2026",
  },
];

export default function DatenschutzPage() {
  return (
    <>
      <title>Datenschutzerklärung – SPDB Studio Zürich</title>
      <meta name="robots" content="noindex, nofollow" />
      <main className="min-h-screen bg-white">
        <Navbar />

        <section className="pt-48 pb-16 px-8 lg:px-16 bg-warm-white">
          <div className="max-w-2xl mx-auto text-center">
            <p className="section-label mb-6">Rechtliches</p>
            <h1 className="font-serif text-5xl text-text-primary font-medium leading-tight mb-6">
              Datenschutz&shy;erklärung
            </h1>
            <span className="gold-divider mb-8" />
            <p className="font-sans font-light text-text-secondary text-sm leading-relaxed">
              Gemäss nDSG 2023 – Letzte Aktualisierung: März 2026
            </p>
          </div>
        </section>

        <section className="py-24 px-8 lg:px-16">
          <div className="max-w-2xl mx-auto flex flex-col gap-12">
            {sections.map((sec) => (
              <div key={sec.title}>
                <h2 className="font-serif text-2xl text-text-primary font-medium mb-5">{sec.title}</h2>
                <p className="font-sans font-light text-text-secondary text-sm leading-relaxed whitespace-pre-line">
                  {sec.content}
                </p>
              </div>
            ))}

            <div className="h-px bg-light-gray" />

            <div className="mt-4">
              <Link to="/impressum" className="inline-flex items-center gap-2 text-xs tracking-luxury font-sans text-gold uppercase hover:opacity-70 transition-opacity duration-300">
                <i className="ri-arrow-right-line" />
                Zurück zum Impressum
              </Link>
            </div>
          </div>
        </section>

        <Footer />
      </main>
    </>
  );
}
